// extracted by mini-css-extract-plugin
module.exports = {"wizardCard":"WizardCard_wizardCard__39QLN","wizardCardDrawer":"WizardCard_wizardCardDrawer__3ANIC","loader":"WizardCard_loader__22e6-"};